import React from 'react';
import PropTypes from 'prop-types';
import Button from "../Button/Button";

const Links = ({ popupHandler, popupData }) => {

  return (
    <div className={"btns-links"}>
      <Button className={"eac-check__step__popup-link"}
              text={"Как выглядит маркировка на&nbsp;телевизоре?"}
              onClick={() => popupHandler(popupData.step1)} />
      <Button className={"eac-check__step__popup-link"}
              text={"Как выглядит номер модели и суффикс?"}
              onClick={() => popupHandler(popupData.step2)} />
    </div>
  );

};

Links.propTypes = {
  popupData: PropTypes.object.isRequired,
  popupHandler: PropTypes.func.isRequired,
};

export default Links;
